'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { startWith } from 'rxjs/operators/startWith';
import { of } from 'rxjs/observable/of';
import { FETCHED_DOMAIN } from '../actions/ActionTypes';
import { receivedDomain, receivedDomainFailure, requestedDomain } from '../actions/DomainActions';
export default ((action$, _, {
  DomainClient
}) => action$.ofType(FETCHED_DOMAIN).pipe(mergeMap(({
  payload: {
    domainName
  }
}) => DomainClient.fetchDomain(domainName).pipe(map(receivedDomain), catchError(error => of(receivedDomainFailure(error))), startWith(requestedDomain())))));